import React from "react";
import "./Shop_by_papers_textures_cards.css";
import Like_heart_btn_holder from "../Like_heart_btn_holder/Like_heart_btn_holder";
import HeartIconComponent from "../HeartIconComponent/HeartIconComponent";
import { Link } from "react-router-dom";
import { encodeId } from "../../../utils/common";

function Shop_by_papers_textures_cards({val}) {
  return (
    <section className="Shop_by_papers_textures_cards">
      <div className="Shop_by_shapes_cards_heart">
        <div className="shapes_cards_img_holder">
          <img
           src={
            process.env.REACT_APP_IMG_URL + val?.Product_Images[0]?.image
          }
            className="shapes_cards_img"
            alt="shapes_cards_img"
          />
        </div>

        <div className="Heart_btn">
        <HeartIconComponent combination_id={val.combination_id} product_id={val?.id} />
        </div>

        {/* <div className="text_holder">
          <h4>Standard</h4>
          <p>100 starting at ₹200.00</p>
        </div> */}
        <Link to={`/product-details-page/${encodeId(val?.id)}`}>
        <div className="text_holder">
          <h4>{val?.name}</h4>
          <p>
            {val?.Product_Combinations[0]?.Qty?.name} starting at ₹
            {Number(val?.Product_Combinations[0]?.total).toFixed(2)}
          </p>
        </div>
      </Link>
      </div>
    </section>
  );
}

export default Shop_by_papers_textures_cards;
